import "./App.css";
import MyProfile from "pages/profile/MyProfile";
import EditProfile from "pages/profile/EditProfile";
import PetDetails from "./pages/petDetails/PetDetails";
import Contact from "pages/contact/Contact";
import AddCareTeam from "pages/add-care-team/AddCareTeam";
import EditPetDetails from "pages/petDetails/EditPetDetails";
import React from "react";
import Home from "./pages/private/home/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "pages/auth/Login";
import SignUp from "pages/auth/SignUp";
import ForgotPassword from "pages/auth/ForgotPassword";
import NewPassword from "pages/auth/NewPassword";
import EnterOTP from "pages/auth/EnterOTP";
import Dashboard from "pages/dashboard/Dashboard";
import LabResult from "pages/dashboard/LabResult";
import MyPets from "pages/private/MyPets";
import LabTests from "pages/private/LabTests";
import ActivationCode from "pages/dashboard/ActivationCode";
import CareTeam from "pages/private/CareTeam";
import Activate from "pages/private/Activate";
import PrintParentResult from "pages/print-result/PrintParentResult";
import VetResult from "components/test-result-template/VetResult";
import "./App.css";
import ParentResult from "components/test-result-template/ParentResult";
import Hospital from "pages/private/Hospital";
import Users from "pages/dashboard/Users";
import AddPetForm from "components/dashboard/Users/AddPet/AddPetForm";
import AddVetForm from "components/dashboard/Users/AddVet/AddVetForm";
import AdminAuth from "components/AuthGaurd/Admin";

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        {/* <UserAuth> */}
        <Routes>
          {/* User Routes */}
          {/* <Route path="/user"> */}
          <Route path="/user/home" element={<Home />} />
          <Route path="/user/my-profile/:userId" element={<MyProfile />} />
          <Route path="/user/edit-profile/:userId" element={<EditProfile />} />
          <Route path="/user/pets" element={<MyPets />} />
          <Route path="/user/hospital" element={<Hospital />} />

          <Route path="/user/pets/pet-details/:petID" element={<PetDetails />} />
          <Route path="/user/pets/edit-pet-details/add" element={<EditPetDetails />} />
          <Route path="/user/pets/edit-pet-details/:path/:petID" element={<EditPetDetails />} />
          <Route path="/user/lab-tests" element={<LabTests />} />
          <Route path="/user/activate/:path" element={<Activate />} />
          <Route path="/user/parent-test-result/:parentTestId" element={<PrintParentResult />} />
          <Route path="/user/my-profile" element={<MyProfile />} />
          <Route path="/user/edit-profile" element={<EditProfile />} />

          <Route path="/user/care-team" element={<CareTeam />} />
          <Route path="/user/care-team/contact-info/:teamId" element={<Contact />} />
          <Route path="/user/care-team/add-care-team/add" element={<AddCareTeam />} />
          <Route path="/user/care-team/add-care-team/add/activate" element={<AddCareTeam />} />
          <Route path="/user/care-team/add-care-team/:path/:teamId" element={<AddCareTeam />} />
          {/* </Route> */}

          <Route path="/parent-test-result" element={<PrintParentResult />} />
          <Route path="/test" element={<ParentResult />} />

          <Route path="/" element={<Login />} />

          {/* Auth Routes */}
          {/* <Route path="/auth"> */}
          <Route path="/auth/sign-up" element={<SignUp />} />
          {/* <Route path="/auth/register/hospital" element={<HospitalForm />} /> */}

          <Route path="/auth/forgot-password" element={<ForgotPassword />} />
          <Route path="/auth/enter-otp/:email/:path" element={<EnterOTP />} />
          <Route path="/auth/new-password/:code/:email" element={<NewPassword />} />
        </Routes>

        {/* admin routes */}
        <AdminAuth>
          <Routes>
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/lab-result" element={<LabResult />} />
            <Route path="/admin/activate-code" element={<ActivationCode />} />
            <Route path="/admin/users" element={<Users />} />
            <Route path="/admin/add-pet/:userId" element={<AddPetForm />} />
            <Route path="/admin/add-care-team/:userId" element={<AddVetForm />} />
            <Route path="/admin/pets/pet-details/:petID" element={<PetDetails />} />
            <Route path="/admin/pets/edit-pet-details/:path/:petID" element={<EditPetDetails />} />

            <Route path="/admin/my-profile/:userId" element={<MyProfile />} />
            <Route path="/admin/edit-profile/:userId" element={<EditProfile />} />
            <Route path="/admin/vet-test-result" element={<VetResult />} />
          </Routes>
        </AdminAuth>
      </BrowserRouter>
    </div>
  );
};

export default App;
